import { render, staticRenderFns } from "./CyclopediaNameAndDescCard.vue?vue&type=template&id=aa8260de&scoped=true&"
import script from "./CyclopediaNameAndDescCard.vue?vue&type=script&lang=js&"
export * from "./CyclopediaNameAndDescCard.vue?vue&type=script&lang=js&"
import style0 from "./CyclopediaNameAndDescCard.vue?vue&type=style&index=0&id=aa8260de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8260de",
  null
  
)

export default component.exports